export default __webpack_public_path__ + "21219d1851ebdfec2d35c15844a73b46.png";